import React, { Component } from "react";

import RSSNewsListConfiguration from "./RSSNewsListConfiguration";
import NewsListOutput from "./NewsListOutput";

class RSSNewsList extends Component {
    render() {
        if (this.props.configuring) {
            return <RSSNewsListConfiguration {...this.props} />;
        }

        return <NewsListOutput {...this.props} />;
    }
}

export default RSSNewsList;
